/**
 * This function filters click and keypress events for those we should consider "positive".
 * Click, Space, and Enter events return true. This allows for keyboard accessibility to
 * events using non-standard HTML elements.
 */
export function eventClick(event: MouseEvent | KeyboardEvent) {
	if (event.type === 'click') {
		return true;
	}

	if (event.type === 'keypress') {
		const {key} = event as KeyboardEvent;
		if ((key === 'Enter') || (key === ' ')) {
			return true;
		}
	}

	return false;
}
